import axios from "axios";
import { store } from '@/store';
import i18n from "@/lang";
import {
  logoutAndShowLogin,
  showBindMobileDialog,
} from "@/utils/authSession";
import {
  isPhoneReverifyError,
  showPhoneVerifyOverlay,
} from "@/utils/phoneVerify";
import {
  getToken,
} from "@/utils/cookies";
console.log("i18n.global.locale.value",i18n.global.locale.value);
//创建实例
const service = axios.create({
  baseURL: "/api", //请求地址
  timeout: 600000, //超时
  // 延时后重新请求次数
  retry: 5,
  //延时后重新请求间隔
  retryInterval: 1000,
  // 设置请求头
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${token}`,
    'locale': i18n.global.locale.value,//localStorage.getItem('lang') || language.split('-')[0] || 'zh',
  },
  responseType: 'json',
});

function parseErrorResponse(error) {
  const response = error?.response;
  if (!response) {
    return { message: error?.message || '网络异常', status: 0, code: null };
  }
  let data = response.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = { message: data };
    }
  }
  const code = data?.code ?? data?.error_code ?? data?.err_code ?? null;
  return {
    message: data?.message || data?.msg || '请求失败',
    status: response.status,
    code,
    data,
  };
}

function handleAccountDisposition(status, code) {
  if (status === 403 && code === 40301) {
    logoutAndShowLogin('账号已冻结，无法操作');
    return true;
  }
  if (status === 403 && code === 40302) {
    logoutAndShowLogin('账号已注销');
    return true;
  }
  if (status === 403 && code === 40303) {
    store.commit('user/SET_RESTRICTED', true);
    ElMessage({
      message: '账号已被限制发布',
      grouping: true,
      type: 'warning',
    });
    return true;
  }
  if (status === 403 && code === 40304) {
    showBindMobileDialog();
    ElMessage({
      message: '请先绑定手机号',
      grouping: true,
      type: 'warning',
    });
    return true;
  }
  if (status === 403 && isPhoneReverifyError({ code })) {
    store.commit('user/SET_PHONE_VERIFY_REQUIRED', true);
    showPhoneVerifyOverlay();
    return true;
  }
  if (status === 401 && code === 40101) {
    logoutAndShowLogin('登录已失效，请重新登录');
    return true;
  }
  return false;
}

//添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // console.log(config,"config");
    // 在发送请求之前做些什么
    config.headers.locale = i18n.global.locale.value;

    if (getToken()) {
      config.headers["Authorization"] = 'Bearer '+getToken(); //携带token Token可以和后端约定
    }
   // + if (getUsername()) {
   //    config.headers["Username"] = getUsername();//Username可以和后端约定
   //  }

    return config;
  },
  function (error) {
    const errorData = parseErrorResponse(error);
    return Promise.reject(errorData);
  }
);
 
// 递归处理数据，将 file:// 替换为 http://
function replaceFileProtocol(obj) {
  if (typeof obj === 'string') {
    return obj.replace(/file:\/\//g, 'http://');
  }
  if (Array.isArray(obj)) {
    return obj.map(item => replaceFileProtocol(item));
  }
  if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = replaceFileProtocol(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

//添加响  应拦截器
service.interceptors.response.use(
  function (response) {
    //对响应数据做些什么
    // console.log("响应数据", response);
    const status = response.status;
    if (status === 200) {
      if (response.data) {
        response.data = replaceFileProtocol(response.data);
      }
      return Promise.resolve(response.data);
    } else {
      console.log('数据获取失败')
      return Promise.reject(response.data || { message: '数据获取失败' });
    }
  },
  function (error) {
    const errorData = parseErrorResponse(error);
    handleAccountDisposition(errorData.status, errorData.code);
    return Promise.reject(errorData);
  }
);
 
//暴露service
export default service;
